var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loadingGame)?_c('TempSelect',{attrs:{"formData":_vm.formData,"id":_vm.id,"customKey":_vm.serverCustomKey,"labelInfo":_vm.labelInfo,"required":_vm.labelInfo.required,"label":_vm.labelInfo.label}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }